// extracted by mini-css-extract-plugin
export default {"characterContainer":"CharacterView_characterContainer__WVaFr","characterSvg":"CharacterView_characterSvg__ghM88"};